import React, { FC } from "react";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
import { fadeIn } from "../../utils/Motion";
import styles from "./ProjectCard.module.scss";
import { F_Open_Sans } from "@/fonts";
import { FaExternalLinkAlt, FaGithub } from "react-icons/fa";
import Image from "next/image";

interface Props {
  index: number;
  name: string;
  description: string;
  tags: {
    name: string;
  }[];
  image: string;
  source_code_link?: string;
  live_page?: string;
}

const ProjectCard: FC<Props> = ({
  index,
  name,
  description,
  tags,
  image,
  source_code_link,
  live_page,
}) => {
  return (
    <motion.div
      className={styles.cardWrapper}
      variants={fadeIn("up", "spring", index * 0.5, 0.75)}
    >
      <Tilt className={styles.card}>
        <div className={styles.imgWrapper}>
          <Image
            priority
            fill
            src={image}
            alt="project_image"
            className={styles.img}
            sizes="(max-width: 768px) 100vw, 400px"
          />
        </div>

        <div className={`${styles.text} ${F_Open_Sans.className}`}>
          <div className={styles.iconsWrapper}>
            <div className={styles.iconsWrapper}>
              {source_code_link && (
                <a
                  href={source_code_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.github}
                  aria-label="View source code on GitHub"
                >
                  <FaGithub />
                </a>
              )}
              {live_page && (
                <a
                  href={live_page}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.livePage}
                  aria-label="View live project"
                >
                  <FaExternalLinkAlt />
                </a>
              )}
            </div>
          </div>
          <h3 className={styles.title}>{name}</h3>
          <p className={styles.description}>{description}</p>

          <div className={styles.tags}>
            {tags.map((tag) => (
              <p key={`${name}-${tag.name}`}>#{tag.name}</p>
            ))}
          </div>
        </div>
      </Tilt>
    </motion.div>
  );
};
export default ProjectCard;
